import { TabsWithClientActions } from "@/components";
import { ClientsTab } from "@/modules/admin/ClientTab";
import { RegionsTab } from "@/modules/admin/RegionTab";
import { UsersTab } from "@/modules/admin/UsersTab";
import { AdminLoading } from "@/modules/admin/AdminLoading";
import { useUpdateHeaderTitle } from "@/hooks/useUpdateHeaderData";
import { useUsers } from "@/hooks/useUsers";
import { useClients } from "@/hooks/useClients";
import { useRoles } from "@/hooks/useRoles";
import { useIndastries } from "@/hooks/useIndastry";
import { useRegions } from "@/hooks/useRegions";
import { useMemo } from "react";

export default function Admin() {
  const { users, userErrors } = useUsers();
  const { clients, clientErrors } = useClients();
  const { regions, regionErrors } = useRegions();
  const { roles, roleErrors } = useRoles();
  const { industries, industryErrors } = useIndastries();
  const errors =
    userErrors || clientErrors || roleErrors || industryErrors || regionErrors;

  useUpdateHeaderTitle("Administration");

  const clientOptions = useMemo(
    () =>
      clients
        ?.map((client) => ({
          label: client.name,
          value: client.id.toString(),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || [],
    [clients]
  );

  const regionOptions = useMemo(
    () =>
      regions
        ?.map((region) => ({
          label: region.name,
          value: region.id.toString(),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || [],
    [regions]
  );

  if (errors) {
    throw new Error(errors);
  }

  if (!(users && clients && roles && industries && regions)) {
    return <AdminLoading />;
  }

  const tabData = [
    {
      label: "Users",
      value: "users",
      content: (
        <UsersTab
          clientOptions={clientOptions}
          regionOptions={regionOptions}
          roleOptions={roles}
          data={users}
        />
      ),
    },
    {
      label: "Clients",
      value: "clients",
      content: <ClientsTab data={clients} industryOptions={industries} />,
    },
    {
      label: "Regions",
      value: "regions",
      content: <RegionsTab data={regions} />,
    },
  ];

  return <TabsWithClientActions defaultValue="users" data={tabData} />;
}
